import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import Tab from '../../../../component/Tabs/Tab';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';
import axios from 'axios';

const ImportExport = () => {
    const navigate = useNavigate();
    const {type} = useParams();//imports/exports

    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const tabHeader = [
        {
            "key": "exports",
            "label": "Export",
        },
        {
            "key": "imports",
            "label": "Import"
        }
    ];

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_DATA = "api/erpppsu/export/export";

    useEffect(() => {
        if (type == 'exports') {
            fetchData(`${BASE_URL}${PATH_DATA}`).then((response) => {
                setData(response);
            });
        } else {
            setData([]);
        }
    }, [type]);

    // Fetch data from the API
    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleTabClick = (tab) => {
        navigate(`/activity-erpppsu/import-export/${tab}`);
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div  className="mx-auto p-4">
            <div className='flex items-center justify-between p-5'>
                <h2 className="text-2xl font-bold">{type.toUpperCase()}</h2>                
            </div>

            <div className="tabs">
                {tabHeader.map((tab) => (
                    <Tab name={tab.key} label={tab.label} activeTab={type} onClick={() => {
                        handleTabClick(tab.key)
                    }} />
                ))}
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTableDynamic
                    data={data}
                    elementClass="p-1"
                    columns={columns}
                    moduleActions={[]}
                    enableCustom={false} />
            )}
        </div>
    );
}

export default ImportExport;
